import React from 'react';

import b_ from 'b_';

import './survey-card-skeleton.css';

const b = b_.with('survey-card-skeleton');

export default function CardSkeleton() {
    return (
        <div className={b()}>
            <div className={b('info')}>
                <div className={b('meta')}>
                    <div className={b('state')} />
                    <div className={b('updated-at')} />
                </div>
                <div className={b('targeting')} />
                <div className={b('name')} />
            </div>
            <div className={b('button')} />
        </div>
    );
}
